export const TOKEN_POLL_INTERVAL_MS = 5_000

export const TOKEN_POLL_TIMEOUT_MS = 5 * 60_000
